const nf = new Intl.NumberFormat('sv-SE');
export const kr = n => (n == null ? '—' : nf.format(Math.round(n)));
export const pct = n => (n == null ? '—' : `${(n * 100).toFixed(0)}%`);
const MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
export const monthLabel = m => MONTHS[+m.slice(5, 7) - 1];
export const monthShort = m => `${monthLabel(m)} ${m.slice(2, 4)}`;

/**
 * Axis tick labels. With 8 periods every one is labelled; with 66 months they would
 * overlap into a grey smear, so only every Nth is drawn. Rows carry their own `tick`
 * (set by lib/periods.js) so the same thinning works for months, quarters, halves and
 * years without this function knowing which grain it was handed.
 */
export function tickLabels(rows) {
	const every = rows.length <= 14 ? 1 : rows.length <= 30 ? 2 : rows.length <= 40 ? 3 : 6;
	return rows.map((r, i) => {
		if (i % every !== 0 && i !== rows.length - 1) return null;
		return r.tick ?? monthShort(r.month);
	});
}
